export default [
    {
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    },
    {
        name: '__slot:rsy_ad_img',
        useInFilter: false,
        defaultSearch: false
    },
    {
        name: '__slot:rsy_ad',
        sortField: 'title',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'second_title',
        sortField: 'second_title',
        type: 'string',
        useInFilter: true,
        defaultSearch: true,
        visible: false,
        switchable: false
    },
    {
        name: 'body',
        sortField: 'body',
        type: 'string',
        useInFilter: true,
        defaultSearch: true,
        visible: false,
        switchable: false
    },
    {
        name: 'url',
        visible: false,
        sortField: 'url',
        type: 'string',
        useInFilter: true,
        defaultSearch: false
    },
    {
        name: 'legal',
        sortField: 'legal',
        type: 'string_without_in',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'type',
        sortField: 'type',
        type: 'arr',
        useInFilter: true,
        defaultSearch: false,
        items: [
            {value: "Директ", label:"Директ"},
            {value: "Медиа", label:"Медиа"},
            {value: "App Store", label:"Моб. приложение (App Store)"},
            {value: "Google Play", label:"Моб. приложение (Google Play)"},
            {value: "Видео", label:"Видео"},
        ],
    },
    {
        name: 'region',
        sortField: 'region_id',
        type: 'regions',
        useInFilter: true,
        defaultSearch: false,
        visible:true,
        switchable: false
    },
    {
        name: 'diff_days',
        sortField: 'diff_days',
        type: 'number',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'found_at',
        sortField: 'found_at',
        type: 'dateRange',
        useInFilter: true,
        defaultSearch: false
    },
    {
        name: 'updated_at',
        sortField: 'updated_at',
        type: 'dateRange',
        useInFilter: true,
        defaultSearch: false
    },
    {
        name: 'size',
        sortField: 'size',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    }
]
